import React from 'react';

const StandardContentBlock = ({ content, heading, mobHeading, mobContent }) => {
  const displayHeading = window.innerWidth < 768 && mobHeading ? mobHeading : heading;
  const displayContent = window.innerWidth < 768 && mobContent ? mobContent : content;
  return (
    <>
      {heading && (
        <h1 data-testid="content-block-title" className="mb-5 content-block-title">
          {displayHeading}
        </h1>
      )}
      <div>
        <div data-testid="content-block-section-text">{displayContent}</div>
      </div>
    </>
  );
};

export { StandardContentBlock };
